// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Edit.scss';
import { observable } from 'mobx';
import Navigation from './Navigation/Navigation';
import ChangePass from './ChangePass/ChangePass';
import ChangeUsername from './ChangeUsername/ChangeUsername';

@observer class Edit extends Component<any, any> {

	tabs: any = {
		changeUsername: <ChangeUsername />,
		changePass: <ChangePass />
	};

	@observable currentTab: string = 'changePass';

	constructor(props: any) {
		super(props);

		this.setTab = this.setTab.bind(this);
	}

	setTab(newTab: string) {
		this.currentTab = newTab;
	}

	render() {
		return (
			<div className="profile-edit">
				<Navigation changeTab={this.setTab} currentTab={this.currentTab} />
				<div className="profile-edit-body">
					{this.tabs[this.currentTab]}
				</div>
			</div>
		)
	}
}

export default Edit;

